import { jsx as l, jsxs as y, Fragment as S } from "react/jsx-runtime";
import C, { useContext as f, createContext as j } from "react";
import B from "clsx";
import { ClientOnly as x } from "@made-people/ui-components-client-only";
import { bannerStyling as u } from "./index-blueprint.es.js";
import { responsiveVideoSchema as A, ResponsiveVideo as G } from "@made-people/blueprint-responsive-video";
import { ResponsiveImage as k, responsiveImageSchema as w } from "@made-people/blueprint-responsive-image";
import { useInGrid as W } from "@made-people/blueprint-grid";
import { z as m } from "zod";
import { withZod as I } from "@made-people/react-prop-guard";
import { buttonAsButtonSchema as M, ButtonAsLink as R } from "@made-people/blueprint-button";
import { linkAsLinkSchema as D, LinkAsLink as P } from "@made-people/blueprint-link";
import { headingSchema as T, Heading as $ } from "@made-people/blueprint-heading";
import { Markdown as E } from "@made-people/blueprint-markdown";
import { useLink as F } from "@made-people/grease-link";
import { withManagedProps as H } from "@made-people/managed-props";
import { componentWrapperSchema as O, ComponentWrapper as Z } from "@made-people/blueprint-component-wrapper";
import { breakpointVisibilitySchema as q, useBreakpoint as J } from "@made-people/blueprint-ui-hooks";
import "@made-people/blueprint";
const K = A, V = C.forwardRef(({ className: e, ...t }, o) => {
  var p, c, s;
  const n = f(h);
  if (!n)
    return null;
  const { variants: i, settings: a } = n;
  if (!(a != null && a.video) || !((p = a == null ? void 0 : a.video) != null && p.src) || typeof a.video.src == "object" && !((c = a.video.src) != null && c.mobile) && !((s = a.video.src) != null && s.desktop))
    return null;
  const r = u.styles(i);
  return /* @__PURE__ */ l(x, { children: /* @__PURE__ */ l(
    G,
    {
      ref: o,
      className: B(r.background, e),
      ...a == null ? void 0 : a.video
    }
  ) });
});
V.displayName = "BackgroundVideo";
const Q = () => {
  var b;
  const e = W(), t = f(h), o = ((b = t == null ? void 0 : t.variants) == null ? void 0 : b.splitImage) === "true";
  if (!t)
    return null;
  const { variants: n, settings: i } = t, a = u.styles(n);
  if (!(i != null && i.image))
    return null;
  const r = t.isMainContent ?? !0, p = r ? "eager" : "lazy", c = r ? "high" : "auto", s = i.splitImage && (() => {
    var N;
    const d = i.splitImage, g = (N = d.initial ?? d.image) == null ? void 0 : N.src, v = d.lg ?? d.desktopImage;
    return g ? d : v != null && v.src ? { ...d, initial: v } : d;
  })();
  return /* @__PURE__ */ y(S, { children: [
    !o && /* @__PURE__ */ l(
      k,
      {
        loading: p,
        fetchpriority: c,
        ...i.image,
        displaySize: e ? t.inGridDisplaySize : i.image.displaySize,
        className: a.background
      }
    ),
    o && s && /* @__PURE__ */ y(S, { children: [
      /* @__PURE__ */ l(
        k,
        {
          loading: p,
          fetchpriority: c,
          ...i.image,
          displaySize: i.image.displaySize,
          className: a.backgroundSplitLeft
        }
      ),
      /* @__PURE__ */ l(
        k,
        {
          loading: p,
          fetchpriority: c,
          ...s,
          displaySize: s.displaySize ?? i.image.displaySize,
          className: a.backgroundSplitRight
        }
      )
    ] })
  ] });
}, L = m.object({
  children: m.custom().array().optional(),
  linkVariants: D.shape.variants.optional(),
  buttonVariants: M.shape.variants.optional()
}), U = I(L, () => {
  var a, r, p, c;
  const e = f(h);
  if (!e)
    return null;
  const { variants: t, settings: o } = e, { ctasWrapper: n } = u.styles(t);
  if (!((r = (a = o == null ? void 0 : o.ctas) == null ? void 0 : a.children) != null && r.length))
    return null;
  const i = (t == null ? void 0 : t.splitImage) === "true";
  return /* @__PURE__ */ l(
    "div",
    {
      className: n,
      "data-split-image": i ? "true" : "false",
      children: (c = (p = o == null ? void 0 : o.ctas) == null ? void 0 : p.children) == null ? void 0 : c.map((s, b) => {
        var d, g;
        if (C.isValidElement(s))
          return s;
        if (s && typeof s == "object" && "component" in s)
          switch (s.component) {
            case "ButtonAsLink":
              return /* @__PURE__ */ l(
                R,
                {
                  variants: (d = o == null ? void 0 : o.ctas) == null ? void 0 : d.buttonVariants,
                  ...s
                },
                `button-${b}`
              );
            case "LinkAsLink":
              return /* @__PURE__ */ l(
                P,
                {
                  variants: (g = o == null ? void 0 : o.ctas) == null ? void 0 : g.linkVariants,
                  ...s
                },
                `link-${b}`
              );
          }
        return null;
      })
    }
  );
}), X = m.object({ label: m.string() }).array(), Y = () => {
  const e = f(h);
  if (!e)
    return null;
  const { variants: t, settings: o } = e, n = o == null ? void 0 : o.tags, i = u.styles(t);
  return n ? /* @__PURE__ */ l("div", { className: i.tagsWrapper, children: n == null ? void 0 : n.map((a, r) => /* @__PURE__ */ l("span", { className: i.tag, children: a.label }, r)) }) : null;
}, z = m.object({
  heading: T.optional(),
  body: m.string().optional()
}), _ = () => {
  var a, r, p, c, s;
  const e = f(h);
  if (!e)
    return null;
  const { variants: t, settings: o } = e, n = u.styles(t);
  return ((a = o == null ? void 0 : o.heading) == null ? void 0 : a.heading) || ((p = (r = o == null ? void 0 : o.heading) == null ? void 0 : r.badge) == null ? void 0 : p.label) || ((c = o == null ? void 0 : o.heading) == null ? void 0 : c.eyebrow) || ((s = o == null ? void 0 : o.heading) == null ? void 0 : s.lead) || (o == null ? void 0 : o.body) || (o == null ? void 0 : o.ctas) || (o == null ? void 0 : o.tags) ? /* @__PURE__ */ y(S, { children: [
    /* @__PURE__ */ y("div", { className: n.contentWrapper, children: [
      /* @__PURE__ */ l(Y, {}),
      /* @__PURE__ */ l($, { ...o == null ? void 0 : o.heading, className: n.headingWrapper }),
      (o == null ? void 0 : o.body) && /* @__PURE__ */ l(E, { content: o.body, className: n.body }),
      /* @__PURE__ */ l(U, {})
    ] }),
    /* @__PURE__ */ l(
      "div",
      {
        className: B(
          "absolute h-full w-full right-0 top-0",
          n.contentShadow
        )
      }
    )
  ] }) : null;
}, oo = () => {
  var a, r;
  const e = f(h), t = F();
  if (!e)
    return null;
  const { variants: o, settings: n } = e, i = u.styles(o);
  return (a = n == null ? void 0 : n.link) != null && a.href ? /* @__PURE__ */ l(
    t,
    {
      className: B("absolute w-full h-full left-0 top-0", i.link),
      href: n == null ? void 0 : n.link.href,
      "aria-label": `Go to ${((r = n.heading) == null ? void 0 : r.heading) ?? "page"}`
    }
  ) : null;
}, ao = (e) => {
  var i, a, r;
  if (!e)
    return { mobile: !1, tablet: !1, desktop: !1 };
  const t = !!((i = e.initial ?? e.image) != null && i.src), o = !!((a = e.md ?? e.tabletImage) != null && a.src), n = !!((r = e.lg ?? e.desktopImage) != null && r.src);
  return {
    mobile: t,
    tablet: t || o,
    desktop: t || o || n
  };
}, no = m.object({
  variants: m.custom().optional(),
  layout: O.shape.layout.optional(),
  settings: m.object({
    tags: X.optional(),
    heading: z.shape.heading.optional(),
    body: z.shape.body.optional(),
    image: w.optional(),
    splitImage: w.optional(),
    video: K.optional(),
    link: m.object({
      href: m.string().optional()
    }).optional(),
    ctas: L.optional()
  }).optional(),
  visibility: q.optional(),
  // Toggles if we should use eager/high priority loading, defaults
  // to true.
  isMainContent: m.boolean().optional(),
  inGridDisplaySize: m.string().optional()
}), h = j(void 0), No = H(
  "Banner",
  I(
    {
      schema: no,
      defaultProps: {
        inGridDisplaySize: "25vw",
        settings: {
          image: {
            displaySize: "100vw"
          }
        }
      }
    },
    ({ layout: e, variants: t, ...o }) => {
      var c;
      const n = J(), i = ao((c = o.settings) == null ? void 0 : c.splitImage), a = n.active && (i[n.active] ?? !1), r = {
        ...t,
        splitImage: a ? "true" : "false"
      }, p = u.styles(r);
      return /* @__PURE__ */ l(h.Provider, { value: { ...o, variants: r }, children: /* @__PURE__ */ y(
        Z,
        {
          className: p.base,
          layout: { ...e },
          visibility: o.visibility,
          children: [
            /* @__PURE__ */ l(V, {}),
            /* @__PURE__ */ l(Q, {}),
            /* @__PURE__ */ l(_, {}),
            /* @__PURE__ */ l(oo, {})
          ]
        }
      ) });
    }
  )
);
export {
  Q as BackgroundImage,
  V as BackgroundVideo,
  No as Banner,
  h as BannerContext,
  no as BannerSchema,
  U as CTAs,
  _ as Content,
  oo as Link,
  Y as Tags,
  K as backgroundVideoSchema,
  z as contentSchema,
  L as ctaSchema,
  ao as splitImageActiveAtBreakpoint,
  X as tagsSchema
};
//# sourceMappingURL=index.es.js.map
